/**
 * @Description
 */
export interface MockDemo {
  a: Function;
}

/** 指派类型 */
export enum ResponsibleAccountType {
  /** 不指派 */
  ASSIGN_NONE = 0,
  /** 指派给自己 */
  ASSIGN_SELF = 1,
  /** 指派给其他成员：开发主管/指派给团队成员 */
  ASSIGN_OTHER = 2,
}
